(() => {
 const root=document.querySelector('.student-content');
 if(!root)return;
 const offer=document.querySelector('[data-ys-launch-offer]');
 const offerEnd=Date.parse(offer?.dataset.endsAt || '2026-10-18T23:00:00Z');
 const widget=root.querySelector('.purchase-follow-widget');
 const purchase=document.querySelector('.yogaspace-product-main product-form form');
  // Keep the floating offer clear of nearby native actions and clocks.
  const offerNeighbours = [...window.document.querySelectorAll('[data-preorder], [data-pricing-countdown], [data-plan-countdown], [role="timer"], button[name="add"]')].filter(el => !el.closest('.purchase-follow-widget'));
  const nearOfferControl = () => offerNeighbours.some(el => {
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && getComputedStyle(el).visibility !== 'hidden' && rect.bottom >= -120 && rect.top <= window.innerHeight + 120;
  });
  const footer = window.document.querySelector('.site-footer, .ypc-yogaspace-brand-footer');
  const footerInView = () => !!footer && footer.getBoundingClientRect().top <= window.innerHeight;
 let purchaseAbove=false;
 const updateWidget=()=>{purchaseAbove=!!purchase&&purchase.getBoundingClientRect().bottom<=0;if(widget)widget.hidden=!purchaseAbove||footerInView()||Date.now()>=offerEnd||!offer||nearOfferControl()};
 if(widget&&offer){
  const label=widget.querySelector('.purchase-follow-widget__timer p');
  const saving=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:offer.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(offer.dataset.saving)/100);
  if(label)label.textContent=`Prices rise by ${saving} in`;
 }
 if(purchase)new IntersectionObserver(([entry])=>{purchaseAbove=entry.boundingClientRect.bottom<=0;updateWidget()},{threshold:0}).observe(purchase);
  let offerScrollFrame = 0;
  const refreshOfferPosition = () => {
    if (offerScrollFrame) return;
    offerScrollFrame = requestAnimationFrame(() => { offerScrollFrame = 0; updateWidget(); });
  };
  window.addEventListener('scroll', refreshOfferPosition, {passive:true});
  window.addEventListener('resize', refreshOfferPosition);
 updateWidget();
 document.addEventListener('visibilitychange',updateWidget);
 const tick=()=>{
  updateWidget();
  const remaining=Math.max(0,Math.ceil((offerEnd-Date.now())/1000));
  root.querySelectorAll('[data-pricing-countdown]').forEach(el=>el.hidden=!remaining);
  const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
  Object.entries(values).forEach(([unit,value])=>root.querySelectorAll(`[data-countdown-${unit}]`).forEach(el=>el.textContent=String(value).padStart(2,'0')));
 };
 tick();setInterval(tick,1000);
 const sources=[...document.querySelectorAll('.yogaspace-product-main [data-ys-plan-price][data-variant-id]')];
 sources.forEach(source=>{
  const sync=()=>root.querySelectorAll(`[data-ys-comparison-price="${CSS.escape(source.dataset.variantId)}"]`).forEach(el=>el.textContent=source.textContent.trim());
  sync();new MutationObserver(sync).observe(source,{childList:true,characterData:true,subtree:true});
 });
 const dialog=root.querySelector('#guide-dialog');
 if(dialog){
  root.querySelector('[data-open-guide]')?.addEventListener('click',()=>dialog.showModal());
  dialog.querySelectorAll('[data-close-dialog]').forEach(el=>el.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('click',event=>{const r=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))dialog.close()});
  dialog.querySelector('iframe')?.addEventListener('load',()=>{dialog.querySelector('iframe').contentDocument?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dialog.close()}})});
 }
 root.querySelectorAll('[data-preorder]').forEach(button=>button.addEventListener('click',async()=>{
  if(button.disabled)return;
  button.disabled=true;button.setAttribute('aria-busy','true');
  let error=root.querySelector('[data-native-purchase-error]');
  if(error)error.remove();
  try{
   const input=[...document.querySelectorAll('.yogaspace-product-main variant-radios input[type=radio]')].find(el=>el.value.toLowerCase()===button.dataset.preorder);
   if(!input)throw new Error('Please select your plan above.');
   input.click();
   const end=Date.now()+12000;
   while(Date.now()<end){
    const form=document.querySelector('.yogaspace-product-main product-form form');
    const add=form?.querySelector('button[name=add]');
    if(form?.querySelector('input[name=id]')?.value===button.dataset.variantId&&add&&!add.disabled&&add.getAttribute('aria-disabled')!=='true')break;
    await new Promise(resolve=>setTimeout(resolve,100));
   }
   const form=document.querySelector('.yogaspace-product-main product-form form');
   const add=form?.querySelector('button[name=add]');
   if(form?.querySelector('input[name=id]')?.value!==button.dataset.variantId||!add||add.disabled||add.getAttribute('aria-disabled')==='true')throw new Error('Please select your plan above.');
   await window.YogaSpaceLaunchOffer?.prepare();
   add.click();
  }catch(failure){
   error=document.createElement('p');error.dataset.nativePurchaseError='';error.className='checkout-error';error.setAttribute('role','alert');error.textContent=failure.message;button.insertAdjacentElement('afterend',error);
  }finally{button.disabled=false;button.removeAttribute('aria-busy')}
 }));
})();